import type {DecorationSingleComponentPluginFunction} from '../../types'
import type {ComponentExportStructure} from '@wix/document-services-types'
import {omitUndefined} from '@wix/document-manager-utils'

export const unpack: DecorationSingleComponentPluginFunction = (vectorImage: ComponentExportStructure) => {
    if (vectorImage.src) {
        vectorImage.data.svgId = vectorImage.src
        delete vectorImage.src
    }

    if (vectorImage.title) {
        vectorImage.data.title = vectorImage.title
        delete vectorImage.title
    }

    if (vectorImage.alt) {
        vectorImage.data.alt = vectorImage.alt
        delete vectorImage.alt
    }

    if (vectorImage.displayMode) {
        vectorImage.props ??= {}
        vectorImage.props.displayMode = vectorImage.displayMode
        delete vectorImage.displayMode
    }

    const {shapeStyle} = vectorImage.design?.default ?? {}

    if (shapeStyle?.stroke) {
        const strokeData = omitUndefined({
            stroke: shapeStyle.stroke.color,
            strokeWidth: shapeStyle.stroke.width,
            strokeOpacity: shapeStyle.stroke.opacity,
            enableStroke: shapeStyle.stroke.enabled
        })

        Object.assign(shapeStyle, strokeData)
    }
}
